import { render, staticRenderFns } from "./DigitInput.vue?vue&type=template&id=43dca7ca&scoped=true"
import script from "./DigitInput.vue?vue&type=script&lang=js"
export * from "./DigitInput.vue?vue&type=script&lang=js"
import style0 from "./DigitInput.vue?vue&type=style&index=0&id=43dca7ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dca7ca",
  null
  
)

export default component.exports